export default "/images/fd2ec41e05137686d67db426142a0e0c.avif";